import React from "react";

export default function Header(params) {
  const { title } = params;
  return (
    <div
      className="bg-[#231C5E] text-white px-12 pb-6 space-y-2"
      style={{ backgroundColor: "#22242C" }}
    >
      <h2>{title}</h2>
    </div>
  );
}
